import { map } from 'lodash';
import { v4 as uuid } from 'uuid';
import { toUUID } from '../../util/transform';
import type { ITicketCommercialLoan } from './TicketCommercialLoan.interface';
import TicketCommercialLoanDetails from './TicketCommercialLoanDetails';
import TicketCommercialLoanFees from './TicketCommercialLoanFees';
import TicketCommercialLoanSecuritySplit from './TicketCommercialLoanSecuritySplit';

export default class TicketCommercialLoan implements ITicketCommercialLoan {
  id: string;
  dealCommercialLoanSecuritySplit: Array<TicketCommercialLoanSecuritySplit>;
  details: TicketCommercialLoanDetails;
  fees: TicketCommercialLoanFees;

  static build = (data: ITicketCommercialLoan) => new TicketCommercialLoan(data);
  static blank = () => new TicketCommercialLoan({ id: uuid() });

  /**
   * Constructor
   * @param {ITicketCommercialLoan} data
   */
  constructor(data?: ITicketCommercialLoan) {
    this.id = toUUID(data?.id) || uuid();
    this.dealCommercialLoanSecuritySplit = map(
      data?.dealCommercialLoanSecuritySplit,
      (obj) => new TicketCommercialLoanSecuritySplit(obj)
    );
    this.details = new TicketCommercialLoanDetails(data?.details);
    this.fees = new TicketCommercialLoanFees(data?.fees);
  }
}
